import React from "react";
import { Route, Switch } from "react-router-dom";

import { ScrollToTop } from "../Common/ScrollToTop";

import { HospitalBookCall } from "./BookCall";
import CreateAccount from "./CreateAccount";
import CreateHospitalProfile from "./CreateHospitalProfile";
import RegistrationComplete from "./RegistrationComplete";
import { RegistrationContextProvider } from "./registrationContext";
import { RegistrationHospitalContinue } from "./RegistrationHospitalContinue";
import WelcomeToRoo from "./WelcomeToRoo";

const RegistrationUpdated = () => {
  return (
    <RegistrationContextProvider>
      <ScrollToTop />
      <Switch>
        <Route path="/register/hospitalBookCall" component={HospitalBookCall} />
        <Route path="/register/hospitalAccount" component={CreateAccount} />
        <Route path="/register/hospitalProfile" component={CreateHospitalProfile} />
        <Route path="/register/success" component={RegistrationComplete} />
        <Route path="/register/hospitalContinue" component={RegistrationHospitalContinue} />
        <Route path="/register" component={WelcomeToRoo} />
      </Switch>
    </RegistrationContextProvider>
  );
};

// eslint-disable-next-line no-restricted-exports
export default RegistrationUpdated;
